import React from 'react';

export default function BrandingForecastSWOT3453534() {
  // Branding plan data derived from the provided sheet
  const brandingPlanRows = [
    // YouTube (CPV)
    { channel: 'YouTube', targeting: 'Dizi', budget: 55000, metric: 'CPV', unitCost: 0.20 },
    { channel: 'YouTube', targeting: 'Finans', budget: 10000, metric: 'CPV', unitCost: 0.20 },
    { channel: 'YouTube', targeting: 'Haber', budget: 10000, metric: 'CPV', unitCost: 0.20 },
    { channel: 'YouTube', targeting: 'Futbol', budget: 10000, metric: 'CPV', unitCost: 0.20 },
    // Google Display Network (CPM)
    { channel: 'Google Display Network', targeting: 'Finans', budget: 5000, metric: 'CPM', unitCost: 35 },
    { channel: 'Google Display Network', targeting: 'Futbol', budget: 7500, metric: 'CPM', unitCost: 35 },
    { channel: 'Google Display Network', targeting: 'Haber', budget: 3000, metric: 'CPM', unitCost: 35 },
    // TV (CPV)
    { channel: 'Kanal D', targeting: 'Uzak Şehir', budget: 22000, metric: 'CPV', unitCost: 0.60 },
    { channel: 'Kanal D', targeting: 'Eşref Rüya', budget: 25000, metric: 'CPV', unitCost: 0.60 },
    { channel: 'Show TV', targeting: 'Veliaht', budget: 15000, metric: 'CPV', unitCost: 0.68 },
    { channel: 'TRT 1', targeting: 'Teşkilat', budget: 20000, metric: 'CPV', unitCost: 0.60 },
    { channel: 'TRT 1', targeting: 'Taşacak Bu Deniz', budget: 7500, metric: 'CPV', unitCost: 0.60 },
    { channel: 'TRT 1', targeting: 'Fetihler Sultanı', budget: 15000, metric: 'CPV', unitCost: 0.60 },
    // Pinterest (CPM)
    { channel: 'Pinterest', targeting: 'Interest', budget: 35000, metric: 'CPM', unitCost: 30 },
  ];

  const formatTL = (n, fd = 0) => `₺${Number(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: fd, maximumFractionDigits: fd })}`;
  const formatInt = (n) => Number(Math.round(n || 0)).toLocaleString('tr-TR');

  // Channel logos in public/
  const channelLogos = {
    'YouTube': '/youtubelogo222.png',
    'Pinterest': '/pinterestlogo.png',
    'Google Display Network': '/google_ads-512.webp',
    'Meta': '/6033716.png',
    'TikTok': '/tiktokv4.svg',
    'Kanal D': '/kanaldlogo.png',
    'Show TV': '/showtvlogo.jpeg',
    'TRT 1': '/TRT1logo.png',
    // Display has no specific logo provided
  };

  // Derived metrics
  const computedRows = brandingPlanRows.map(r => {
    const views = r.metric === 'CPV' ? (r.budget / r.unitCost) : null;
    const impressions = r.metric === 'CPM' ? ((r.budget / r.unitCost) * 1000) : null;
    return { ...r, views, impressions };
  });

  // Second plan for Gürgençler x Fibabank
  const ggfbTargetingSegments = [
    'New User - Young Professionals (White Collar)',
    'New User - Value & Deal Hunters',
    'New User - Tech Enthusiasts & Gadget Lovers',
    'Remarketing - Banking Deals Page Visitors',
  ];
  const ggfbTargetingWeights = {
    'New User - Young Professionals (White Collar)': 0.40,
    'New User - Value & Deal Hunters': 0.25,
    'New User - Tech Enthusiasts & Gadget Lovers': 0.15,
    'Remarketing - Banking Deals Page Visitors': 0.20,
  };
  const ggfbBaseRows = [
    // Meta (CPM) with separate objectives
    { channel: 'Meta', objective: 'Awareness', budget: 120000, metric: 'CPM', unitCost: 35 },
    { channel: 'Meta', objective: 'Traffic', budget: 85000, metric: 'CPC', unitCost: 0.85 },
    // TikTok (CPM) only Awareness
    { channel: 'TikTok', objective: 'Awareness', budget: 45000, metric: 'CPM', unitCost: 28 },
  ];
  const ggfbPlanRows = ggfbBaseRows.flatMap(base =>
    ggfbTargetingSegments.map(seg => ({
      ...base,
      targeting: seg,
      budget: Math.round(base.budget * ggfbTargetingWeights[seg]),
    }))
  );

  const computedRowsGGFB = ggfbPlanRows.map(r => {
    const views = r.metric === 'CPV' ? (r.budget / r.unitCost) : null;
    const impressions = r.metric === 'CPM' ? ((r.budget / r.unitCost) * 1000) : null;
    const clicks = r.metric === 'CPC' ? (r.budget / r.unitCost) : null;
    return { ...r, views, impressions, clicks };
  });

  // Group rows by channel for UI rowSpan
  const groupedByChannel = computedRows.reduce((acc, r) => {
    if (!acc[r.channel]) acc[r.channel] = [];
    acc[r.channel].push(r);
    return acc;
  }, {});

  const groupedByChannelGGFB = computedRowsGGFB.reduce((acc, r) => {
    if (!acc[r.channel]) acc[r.channel] = [];
    acc[r.channel].push(r);
    return acc;
  }, {});

  const grandTotals = computedRows.reduce((acc, r) => {
    acc.budget += r.budget;
    acc.views += (r.views || 0);
    acc.impressions += (r.impressions || 0);
    return acc;
  }, { budget: 0, views: 0, impressions: 0 });

  const grandTotalsGGFB = computedRowsGGFB.reduce((acc, r) => {
    acc.budget += r.budget;
    acc.clicks += (r.clicks || 0);
    acc.impressions += (r.impressions || 0);
    return acc;
  }, { budget: 0, clicks: 0, impressions: 0 });

  // YouTube Targeting lists (leave empty for now)
  const ytTargeting = {
    dizi: [
      'Uzak Şehir',
      'Taşacak Bu Deniz',
      'Eşref Rüya',
      'Halef',
      'Güller ve Günahlar',
      'Teşkilat',
      'Dünül Dağı',
      'Kızılcık Şerbeti',
      'Sahtekarlar',
      'Bahar',
      'Veliaht',
      'Kral Kaybederse',
      'Arka Sokaklar',
      'Fetihler Sultanı'
    ],
    finans: [
      'Bloomberg HT',
      'A Para',
      'Ekotürk TV',
      'Para Analiz',
      'Midas',
      'InvestAZ',
      'Economy TV',
      'Kripto Teknik',
      'Kriptometre',
      'Finans Merkezi'
    ],
    haber: [
      'TRT Haber',
      'Anadolu Ajansı',
      'CNN Türk',
      'NTV',
      'Haber Global',
      'Halk TV',
      'FOX Haber',
      'Show Haber',
      'Sözcü TV',
      'Sabah'
    ],
    futbol: [
      'beIN SPORTS Türkiye',
      'A Spor',
      'S Sport',
      'Futbol Arena',
      'Maçkolik',
      'Spor Arena',
      'Tivibu Spor',
      'Fenerbahçe SK',
      'Galatasaray',
      'Beşiktaş JK'
    ]
  };

  return (
    <>
    <div className="p-6">
      {/* --- SWOT Analysis --- */}
      <div className="mt-12 mb-16 w-full max-w-6xl mx-auto">
        <div className="rounded-3xl shadow-2xl bg-gradient-to-br from-[#f8f7fc] via-[#ede7f6] to-[#e3e8ff] p-1">
          <div className="bg-white rounded-3xl p-8 md:p-12">
            <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-12 tracking-tight bg-gradient-to-r from-[#9A80CA] to-[#4F8CFF] bg-clip-text text-transparent" style={{letterSpacing: '-0.03em'}}>SWOT Analysis</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              {/* Strengths */}
              <div className="rounded-2xl shadow-lg bg-gradient-to-b from-[#9A80CA] to-[#bba6e6] p-0.5">
                <div className="bg-white rounded-2xl p-6 h-full flex flex-col">
                  <div className="text-lg font-bold text-white bg-gradient-to-r from-[#9A80CA] to-[#7C5DB0] rounded-xl px-4 py-2 mb-4 text-center shadow">Strengths</div>
                  <ul className="text-sm text-gray-700 space-y-3 list-disc pl-5">
                    <li>Geniş erkek giyim ürün yelpazesi (takım elbise, gömlek, aksesuar)</li>
                    <li>Vade farksız 6 ay taksit imkanı</li>
                    <li>Müşteri destek kanalları (telefon, WhatsApp, e-mail)</li>
                  </ul>
                </div>
              </div>
              {/* Weaknesses */}
              <div className="rounded-2xl shadow-lg bg-gradient-to-b from-[#bba6e6] to-[#ede7f6] p-0.5">
                <div className="bg-white rounded-2xl p-6 h-full flex flex-col">
                  <div className="text-lg font-bold text-white bg-gradient-to-r from-[#7C5DB0] to-[#9A80CA] rounded-xl px-4 py-2 mb-4 text-center shadow">Weaknesses</div>
                  <ul className="text-sm text-gray-700 space-y-3 list-disc pl-5">
                    <li>Sadece erkek giyim segmentinde faaliyet (hedef kitle sınırlı)</li>
                    <li>Yüksek kargo baremi (2000 TL üzeri, rakipler daha düşük veriyor)</li>
                    <li>Yazlık ürünlerde sınırlı seçenek (keten gömlek, şort vb.)</li>
                    <li>Yüksek sepet ortalaması, giriş seviyesi ürün eksikliği</li>
                    <li>Online deneyim zayıf, kullanıcı bilgilendirme sistemleri geliştirilmeli</li>
                    <li>Güçlü marka bilinirliği eksikliği (yerel rakipler karşısında)</li>
                    <li>Ticimax altyapısı ile sınırlı özelleştirme imkanları</li>
                    <li>Sosyal medya takipçi sayısının düşük olması</li>
                  </ul>
                </div>
              </div>
              {/* Opportunities */}
              <div className="rounded-2xl shadow-lg bg-gradient-to-b from-[#4F8CFF] to-[#bba6e6] p-0.5">
                <div className="bg-white rounded-2xl p-6 h-full flex flex-col">
                  <div className="text-lg font-bold text-white bg-gradient-to-r from-[#4F8CFF] to-[#9A80CA] rounded-xl px-4 py-2 mb-4 text-center shadow">Opportunities</div>
                  <ul className="text-sm text-gray-700 space-y-3 list-disc pl-5">
                    <li>Yaz aylarında aranması artan ürün gruplarına sahiplik (keten, polo)</li>
                    <li>Back-to-school ve iş başlama dönemi için hazırlık yapma imkanı</li>
                    <li>Düğün sezonunda takım elbise ve smokin talebindeki artış</li>
                    <li>Mezuniyet dönemlerinde formalwear kategorisinde fırsat</li>
                  </ul>
                </div>
              </div>
              {/* Threats */}
              <div className="rounded-2xl shadow-lg bg-gradient-to-b from-[#ede7f6] to-[#bba6e6] p-0.5">
                <div className="bg-white rounded-2xl p-6 h-full flex flex-col">
                  <div className="text-lg font-bold text-white bg-gradient-to-r from-[#9A80CA] to-[#4F8CFF] rounded-xl px-4 py-2 mb-4 text-center shadow">Threats</div>
                  <ul className="text-sm text-gray-700 space-y-3 list-disc pl-5">
                    <li>Koton, LC Waikiki gibi büyük markaların agresif fiyat politikaları</li>
                    <li>Rakiplerin pazar yerlerinde özellikle Trendyol'daki güçlü varlığı</li>
                    <li>Ekonomik dalgalanmalar ve TL'deki değer kaybının etkisi</li>
                    <li>Dijital reklam maliyetlerinin sürekli artış eğilimi</li>
                    <li>Fast fashion trendinin iş giyim segmentindeki etkisi</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    {/* --- Branding Plan (Unit Costs, Estimated Volume) --- */}
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden mt-8 w-full max-w-6xl mx-auto">
      <div className="p-5 flex justify-between items-center bg-black text-white">
        <h2 className="text-xl font-bold text-white">Branding Plan</h2>
        <img src="/jakamenlogo.webp" alt="Jakamen Logo" className="h-8 w-auto object-contain" />
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '16%' }}>Channel</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '24%' }}>Targeting</th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '10%' }}>Metric</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '12%' }}>Unit Cost</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '14%' }}>Budget</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '12%' }}>Est. Views</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '12%' }}>Est. Impr.</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {Object.keys(groupedByChannel).map(channel => {
              const rows = groupedByChannel[channel];
              return rows.map((r, idx) => (
                <tr key={`${channel}-${idx}`} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  {idx === 0 ? (
                    <td className="px-4 py-3 text-sm font-medium text-gray-900 text-center align-middle" rowSpan={rows.length}>
                      <div className="flex items-center justify-center gap-2">
                        {channelLogos[channel] && (
                          <img src={channelLogos[channel]} alt={`${channel} logo`} className="w-5 h-5 object-contain" />
                        )}
                        <span>{channel}</span>
                      </div>
                    </td>
                  ) : null}
                  <td className="px-4 py-3 text-sm text-gray-700">{r.targeting}</td>
                  <td className="px-4 py-3 text-sm text-center text-gray-700">{r.metric}</td>
                  <td className="px-4 py-3 text-sm text-right text-gray-700">{r.metric === 'CPM' ? formatTL(r.unitCost) : formatTL(r.unitCost, 2)}</td>
                  <td className="px-4 py-3 text-sm text-right font-medium">{formatTL(r.budget)}</td>
                  <td className="px-4 py-3 text-sm text-right text-gray-700">{r.views != null ? formatInt(r.views) : '-'}</td>
                  <td className="px-4 py-3 text-sm text-right text-gray-700">{r.impressions != null ? formatInt(r.impressions) : '-'}</td>
                </tr>
              ));
            })}
            <tr className="bg-gray-100 font-semibold">
              <td className="px-4 py-3 text-sm" colSpan={4}>TOTAL</td>
              <td className="px-4 py-3 text-sm text-right">{formatTL(grandTotals.budget)}</td>
              <td className="px-4 py-3 text-sm text-right">{formatInt(grandTotals.views)}</td>
              <td className="px-4 py-3 text-sm text-right">{formatInt(grandTotals.impressions)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="p-4 text-xs text-gray-500 bg-gray-50 border-t">
        Varsayımlar: YouTube & Video CPV değerleri {formatTL(0.20, 2)} ve {formatTL(0.18, 2)} olarak, Display & Pinterest CPM değerleri {formatTL(35)} ve {formatTL(30)} olarak alınmıştır. İstenirse hızlıca güncelleyebilirim.
      </div>
    </div>

    {/* --- Branding Plan (Gürgençler x Fibabank) --- */}
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden mt-8 w-full max-w-6xl mx-auto">
      <div className="p-5 flex justify-between items-center bg-black text-white">
        <h2 className="text-xl font-bold text-white">Branding Plan — Gürgençler x Fibabank</h2>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '16%' }}>Channel</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '18%' }}>Objective</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '18%' }}>Targeting</th>
              <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '10%' }}>Metric</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '10%' }}>Unit Cost</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '14%' }}>Budget</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '7%' }}>Est. Clicks</th>
              <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" style={{ width: '7%' }}>Est. Impr.</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {Object.keys(groupedByChannelGGFB).map(channel => {
              const rows = groupedByChannelGGFB[channel];
              return rows.map((r, idx) => (
                <tr key={`${channel}-${idx}`} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  {idx === 0 ? (
                    <td className="px-4 py-3 text-sm font-medium text-gray-900 text-center align-middle" rowSpan={rows.length}>
                      <div className="flex items-center justify-center gap-2">
                        {channelLogos[channel] && (
                          <img src={channelLogos[channel]} alt={`${channel} logo`} className="w-5 h-5 object-contain" />
                        )}
                        <span>{channel}</span>
                      </div>
                    </td>
                  ) : null}
                  <td className="px-4 py-3 text-sm text-gray-700">{r.objective}</td>
                  <td className="px-4 py-3 text-sm text-gray-700">{r.targeting}</td>
                  <td className="px-4 py-3 text-sm text-center text-gray-700">{r.metric}</td>
                  <td className="px-4 py-3 text-sm text-right text-gray-700">{r.metric === 'CPM' ? formatTL(r.unitCost) : formatTL(r.unitCost, 2)}</td>
                  <td className="px-4 py-3 text-sm text-right font-medium">{formatTL(r.budget)}</td>
                  <td className="px-4 py-3 text-sm text-right text-gray-700">{r.clicks != null ? formatInt(r.clicks) : '-'}</td>
                  <td className="px-4 py-3 text-sm text-right text-gray-700">{r.impressions != null ? formatInt(r.impressions) : '-'}</td>
                </tr>
              ));
            })}
            <tr className="bg-gray-100 font-semibold">
              <td className="px-4 py-3 text-sm" colSpan={5}>TOTAL</td>
              <td className="px-4 py-3 text-sm text-right">{formatTL(grandTotalsGGFB.budget)}</td>
              <td className="px-4 py-3 text-sm text-right">{formatInt(grandTotalsGGFB.clicks)}</td>
              <td className="px-4 py-3 text-sm text-right">{formatInt(grandTotalsGGFB.impressions)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="p-4 text-xs text-gray-500 bg-gray-50 border-t">
        Varsayımlar: Meta Awareness için CPM {formatTL(35)}, Meta Traffic için CPC {formatTL(0.85, 2)}, TikTok Awareness için CPM {formatTL(28)} olarak alınmıştır. Bütçe dağılımı Meta {formatTL(205000)} (Awareness + Traffic) ve TikTok {formatTL(45000)} şeklindedir. Targeting dağılımı Young Professionals (White Collar) %40, Value Hunters %25, Tech Enthusiasts %15 ve Banking Deals Visitors (Remarketing) %20 olarak güncellenmiştir. Ana odak taksit/kredi potansiyeli yüksek beyaz yakalılar ve teknoloji tutkunlarıdır.
      </div>
    </div>

    {/* --- YouTube Targeting --- */}
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden mt-8 w-full max-w-6xl mx-auto">
      <div className="p-5 flex justify-between items-center bg-black text-white">
        <h2 className="text-xl font-bold text-white">YouTube Targeting</h2>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Dizi</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Finans</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Haber</th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Futbol</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            <tr>
              <td className="px-4 py-3 align-top">
                <ul className="text-sm text-gray-700 space-y-2">
                  {ytTargeting.dizi.length ? ytTargeting.dizi.map((v, i) => (<li key={i}>{v}</li>)) : <li className="h-6"></li>}
                </ul>
              </td>
              <td className="px-4 py-3 align-top">
                <ul className="text-sm text-gray-700 space-y-2">
                  {ytTargeting.finans.length ? ytTargeting.finans.map((v, i) => (<li key={i}>{v}</li>)) : <li className="h-6"></li>}
                </ul>
              </td>
              <td className="px-4 py-3 align-top">
                <ul className="text-sm text-gray-700 space-y-2">
                  {ytTargeting.haber.length ? ytTargeting.haber.map((v, i) => (<li key={i}>{v}</li>)) : <li className="h-6"></li>}
                </ul>
              </td>
              <td className="px-4 py-3 align-top">
                <ul className="text-sm text-gray-700 space-y-2">
                  {ytTargeting.futbol.length ? ytTargeting.futbol.map((v, i) => (<li key={i}>{v}</li>)) : <li className="h-6"></li>}
                </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    {/* --- Display Placement Targeting --- */}
    {(() => {
      const displayPlacement = {
        finans: [
          'https://bigpara.hurriyet.com.tr/',
          'https://www.bloomberght.com/',
          'https://www.paraanaliz.com/',
          'https://finans.mynet.com/',
          'https://www.ekonomist.com.tr/',
          'https://www.finansingundemi.com/',
          'https://uzmanpara.milliyet.com.tr/canli-borsa/',
          'https://tr.euronews.com/tag/finans',
          'https://www.ekonomim.com/',
          'https://www.apara.com.tr/',
          'https://finans.cnnturk.com/',
          'https://www.haberturk.com/ekonomi'
        ],
        futbol: [
          'https://www.ntvspor.net/',
          'https://www.fanatik.com.tr/',
          'https://www.fotomac.com.tr/',
          'https://spor.haber7.com/',
          'https://www.aspor.com.tr/',
          'https://tr.beinsports.com/',
          'https://www.goal.com/tr',
          'https://www.tff.org/',
          'https://www.mackolik.com/',
          'https://skor.sozcu.com.tr/'
        ],
        haber: [
          'https://www.hurriyet.com.tr/',
          'https://www.milliyet.com.tr/',
          'https://www.sabah.com.tr/',
          'https://www.sozcu.com.tr/',
          'https://www.haberturk.com/',
          'https://www.cnnturk.com/',
          'https://www.ntv.com.tr/',
          'https://www.ensonhaber.com/',
          'https://www.aa.com.tr/tr',
          'https://www.trthaber.com/'
        ]
      };
      const getDisplayName = (rawUrl) => {
        try {
          const withProto = rawUrl.startsWith('http') ? rawUrl : `https://${rawUrl}`;
          const u = new URL(withProto);
          let host = u.hostname.replace(/^www\./, '');
          const parts = host.split('.');
          const tlds = new Set(['com','tr','net','org','co','gov','edu','io','ai','app','news','tv']);
          while (parts.length && tlds.has(parts[parts.length - 1])) parts.pop();
          return parts.map(p => p.replace(/-/g, ' ')).join(' ');
        } catch (e) {
          return rawUrl;
        }
      };
      return (
        <div className="bg-white rounded-xl shadow-sm border overflow-hidden mt-8 w-full max-w-6xl mx-auto">
          <div className="p-5 flex justify-between items-center bg-black text-white">
            <h2 className="text-xl font-bold text-white">Display Placement Targeting</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Finans</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Futbol</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Haber</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                <tr>
                  <td className="px-4 py-3 align-top">
                    <ul className="text-sm text-blue-700 space-y-2">
                      {displayPlacement.finans.map((url, i) => (
                        <li key={i}>
                          <a href={url} target="_blank" rel="noopener noreferrer" className="hover:underline">{getDisplayName(url)}</a>
                        </li>
                      ))}
                    </ul>
                  </td>
                  <td className="px-4 py-3 align-top">
                    <ul className="text-sm text-gray-700 space-y-2">
                      {displayPlacement.futbol.length ? displayPlacement.futbol.map((v, i) => (<li key={i}>{v}</li>)) : <li className="h-6"></li>}
                    </ul>
                  </td>
                  <td className="px-4 py-3 align-top">
                    <ul className="text-sm text-gray-700 space-y-2">
                      {displayPlacement.haber.length ? displayPlacement.haber.map((v, i) => (<li key={i}>{v}</li>)) : <li className="h-6"></li>}
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    })()}

    {/* --- Custom Intent (Search Terms) --- */}
    {(() => {
      const generic = [
        'takım elbise',
        'smokin',
        'erkek gömlek',
        'erkek ceket',
        'düğün damatlık',
        'ofis kıyafeti',
        'kişiye özel dikim',
      ];
      const brands = {
        Beymen: [
          'beymen takım elbise',
          'beymen smokin',
          'beymen gömlek',
          'beymen damatlık',
          'beymen erkek ceket',
        ],
        Hatemoğlu: [
          'hatemoğlu takım elbise',
          'hatemoğlu smokin',
          'hatemoğlu gömlek',
          'hatemoğlu damatlık',
          'hatemoğlu ceket',
        ],
        'Altınyıldız': [
          'altınyıldız takım elbise',
          'altınyıldız smokin',
          'altınyıldız gömlek',
          'altınyıldız damatlık',
          'altınyıldız ceket',
        ],
        Ramsey: [
          'ramsey takım elbise',
          'ramsey smokin',
          'ramsey gömlek',
          'ramsey damatlık',
          'ramsey ceket',
        ],
      };

      return (
        <div className="bg-white rounded-xl shadow-sm border overflow-hidden mt-8 w-full max-w-6xl mx-auto">
          <div className="p-5 flex justify-between items-center bg-black text-white">
            <h2 className="text-xl font-bold text-white">Custom Intent — Arama Terimleri</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Generic</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Beymen</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Hatemoğlu</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Altınyıldız</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">Ramsey</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                <tr>
                  <td className="px-4 py-3 align-top">
                    <ul className="text-sm text-gray-700 space-y-2">
                      {generic.map((v,i) => (<li key={i}>{v}</li>))}
                    </ul>
                  </td>
                  {Object.keys(brands).map((b) => (
                    <td key={b} className="px-4 py-3 align-top">
                      <ul className="text-sm text-gray-700 space-y-2">
                        {brands[b].map((v,i) => (<li key={i}>{v}</li>))}
                      </ul>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    })()}

    {/* --- Interest / Affinity Targeting --- */}
    {(() => {
      const interests = {
        Affinity: [
          'Erkek giyim meraklıları',
          'Lüks alışveriş tutkunları',
          'Moda ve stil takipçileri',
          'Düğün hazırlıkları',
          'Kurumsal/Ofis çalışanları',
        ],
        'In‑Market': [
          'Takım elbise ve damatlık alıcıları',
          'Erkek gömlek alıcıları',
          'Erkek ceket alıcıları',
          'Online giyim alışverişi',
        ],
      };

      return (
        <div className="bg-white rounded-xl shadow-sm border overflow-hidden mt-8 w-full max-w-6xl mx-auto">
          <div className="p-5 flex justify-between items-center bg-black text-white">
            <h2 className="text-xl font-bold text-white">Interest / Affinity Targeting</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr className="bg-gray-50">
                  {Object.keys(interests).map((g) => (
                    <th key={g} className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">{g}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                <tr>
                  {Object.keys(interests).map((g) => (
                    <td key={g} className="px-4 py-3 align-top">
                      <ul className="text-sm text-gray-700 space-y-2">
                        {interests[g].map((v,i) => (<li key={i}>{v}</li>))}
                      </ul>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      );
    })()}
    </>
  );
}


